<div class="frame__wrapper" *ngIf="frameService.visible">
    <iframe class="frame" [src]="sanitizer.bypassSecurityTrustResourceUrl(floors[(floorService.selectedFloor | async) - 1][selectedFrame.url])"></iframe>
    <i class="frame__close" (click)="close()">X</i>
</div>
